import React, { useEffect, useState } from 'react';
import { TextField } from '../../components/ui';
import { useDebounce } from '../../utils/useDebounce';

const PasswordChangeForm = ({
  serverError,
  setServerError,
  title,
  handleSubmit,
  handleClick,
}) => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [confirmPasswordError, setConfirmPasswordError] = useState('');

  const debouncedPassword = useDebounce(password, 300);
  const debouncedConfirmPassword = useDebounce(confirmPassword, 300);

  useEffect(() => {
     // Define regular expressions for each category
     const lengthRequirement = password.length >= 10;
     const hasUppercase = /[\p{Lu}]/u.test(password);  // Uppercase letters (Unicode)
     const hasLowercase = /[\p{Ll}]/u.test(password);  // Lowercase letters (Unicode)
     const hasDigit = /\d/.test(password);  // Digits (0-9)
     const hasSpecialChar = /[~!@#$%^&*()_\-+=\\[\]{}:;"'<>,.?/]/.test(password);  // Special characters
 
     // Calculate valid categories
     let validCategories = 0;
     if (hasUppercase) validCategories++;
     if (hasLowercase) validCategories++;
     if (hasDigit) validCategories++;
     if (hasSpecialChar) validCategories++;
 
     // Final validation: password is valid if it satisfies at least 3 categories and has a minimum length of 10
     const isValid = password.length === 0 || (lengthRequirement && validCategories >= 3);
 
    // Update the validation state
    if (!isValid) {
      setPasswordError('Ο κωδικός δεν πληροί τις προυποθέσεις');
    } else {
      setPasswordError('');
    }
  }, [debouncedPassword])
  
  useEffect(() => {
    if (confirmPassword && password !== confirmPassword) {
      setConfirmPasswordError(
        'Οι κωδικοί δεν ταιριάζουν'
      );
    } else {
      setConfirmPasswordError('')
    }
  }, [debouncedPassword, debouncedConfirmPassword])
  
  return (
    <div
      className="w-[100vw] flex items-center justify-center"
      style={{ height: 'calc(100vh - 72px)' }}
    >
      <form
        onSubmit={(event) => {
          event.preventDefault();
          handleSubmit({ password, confirmPassword });
        }}
        className="flex flex-col items-center justify-center gap-10 lg:px-44 bg-white rounded-[20px] py-10"
      >
        <h2>{title}</h2>
        <div className="flex flex-col gap-8 items-center w-72">
          <TextField
            value={password}
            onChange={(e) => {
              // confirmPasswordError && setConfirmPasswordError('');
              serverError && setServerError('');
              setPassword(e.target.value.trim());
            }}
            className={
              'p-2 border border-[#A5A5A5] rounded-[8px] w-72 text-black'
            }
            label={'Νέος Κωδικός'}
            placeholder={'Συμπλήρωσε τον νέο κωδικό'}
            type={'password'}
            id="password"
            error={passwordError}
          />
          <TextField
            value={confirmPassword}
            onChange={(e) => {
              // confirmPasswordError && setConfirmPasswordError('');
              serverError && setServerError('');
              setConfirmPassword(e.target.value.trim());
            }}
            className={
              'p-2 border border-[#A5A5A5] rounded-[8px] w-72 text-black'
            }
            label={'Επιβεβαίωση Νέου Κωδικού'}
            placeholder={'Επιβεβαίωσε τον νέο κωδικό'}
            type={'password'}
            id="confirmPassword"
            error={confirmPasswordError || serverError}
          />
          <div className="flex gap-4">
            <button
              type="button"
              className="btn-secondary text-secondary-button"
              onClick={handleClick}
            >
              Επιστροφή
            </button>

            <button
              type="submit"
              disabled={
                debouncedPassword === '' ||
                debouncedConfirmPassword === '' ||
                confirmPasswordError !== '' ||
                passwordError !== '' ||
                serverError
              }
              className="btn-primary text-primary-button"
            >
              Υποβολή
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default PasswordChangeForm;
